const s_utils = {
  FormatMoney(cents) {
    return theme.Currency.formatMoney(cents);
  },
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);

    observer.observe(node, config);
    return observer;
  },
};

document.addEventListener("alpine:init", () => {
  Alpine.data("CollectionGrid", () => ({
    flags: {
      open_filters: false,
      filters_active: false,
    },
    init() {
      this.InitWatchers();
      setTimeout(this.CheckActiveFilters.bind(this), 1000);
    },
    InitWatchers() {
      let am = this;
      document.addEventListener(
        "filtering:done",
        this.CheckActiveFilters.bind(this),
      );
    },
    CheckActiveFilters() {
      let $active_tags = document.querySelectorAll(
        ".tag-filter__item.is-active",
      );
      this.flags.filters_active = $active_tags.length > 0;
    },
    e_ClearFilters() {
      document
        .querySelectorAll(".is-active .tag-filter__clear")
        .forEach(($button, index) => {
          setTimeout(() => {
            $button.dispatchEvent(new Event("click", { bubbles: true }));
          }, index * 10);
        });
    },
  }));
});
